import { CropActivityReport, DashboardSample, Intervention, Recommendation, Scouting } from '@agroone/entities'
import { Pipe, PipeTransform } from '@angular/core'
import { format } from 'date-fns'
import { dateOf } from '../utils/date-of.util'

@Pipe({
  name: 'itemsByDate',
})
export class ItemsByDatePipe implements PipeTransform {
  transform(report: CropActivityReport): {
    date: string
    items: (Scouting | Recommendation | Intervention | DashboardSample)[]
  }[] {
    return [...report.scoutings, ...report.recommendations, ...report.interventions, ...report.samples]
      .reduce(
        (
          result: {
            date: string
            items: (Scouting | Recommendation | Intervention | DashboardSample)[]
          }[],
          item: Scouting | Recommendation | Intervention | DashboardSample,
        ) => {
          const itemDate: string = format(dateOf(item.date), 'yyyy-MM-dd')
          const foundItem = result.find((i) => format(new Date(i.date), 'yyyy-MM-dd') === itemDate)
          if (!foundItem) {
            result.push({
              date: itemDate,
              items: [item],
            })
          } else {
            foundItem.items.push(item)
          }
          return result
        },
        [],
      )
      .sort((x, y) => new Date(y.date).getTime() - new Date(x.date).getTime())
  }
}
